import { Metric } from "../types";

export const getColor = (
  score: number,
  maxScore: number
): "green" | "red" | "orange" => {
  const percentage = (score / maxScore) * 100;
  if (percentage >= 70) return "green";
  if (percentage >= 40) return "orange";
  return "red";
};

export const getScoreColor = (score: number): string => {
  if (score >= 70) return "#10b981";
  if (score >= 50) return "#f59e0b";
  return "#ef4444";
};

export const getOverallScore = (feedback: any): number => {
  if (!feedback) return 0;
  const score = feedback.overallScore || 0;
  return score < 10 ? score * 10 : score;
};

export const getPerformanceMetrics = (feedback: any): Metric[] => {
  if (!feedback) return [];

  const metrics = [
    {
      id: "clarityStructure",
      name: "Clarity of thought",
      score: feedback.clarityStructure?.score || 0,
      maxScore: feedback.clarityStructure?.maxScore || 10,
      ...feedback.clarityStructure,
    },
    {
      id: "relevance",
      name: "Relevance",
      score: feedback.relevance?.score || 0,
      maxScore: feedback.relevance?.maxScore || 10,
      ...feedback.relevance,
    },
    {
      id: "depthSpecificity",
      name: "Depth and specificity",
      score: feedback.depthSpecificity?.score || 0,
      maxScore: feedback.depthSpecificity?.maxScore || 10,
      ...feedback.depthSpecificity,
    },
    {
      id: "communicationStyle",
      name: "Communication style",
      score: feedback.communicationStyle?.score || 0,
      maxScore: feedback.communicationStyle?.maxScore || 10,
      ...feedback.communicationStyle,
    },
    {
      id: "roleAlignment",
      name: "Role alignment",
      score: feedback.roleAlignment?.score || 0,
      maxScore: feedback.roleAlignment?.maxScore || 10,
      ...feedback.roleAlignment,
    },
    {
      id: "improvementOverTime",
      name: "Improvement over time",
      score: feedback.improvementOverTime?.score || 0,
      maxScore: feedback.improvementOverTime?.maxScore || 10,
      ...feedback.improvementOverTime,
    },
  ];

  return metrics.map((metric) => ({
    ...metric,
    color: getColor(metric.score, metric.maxScore),
    rating: metric.status || "Needs Improvement",
  }));
};

